import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ResultsSection from '../../components/ListingScore/components/ResultsSection';
import { navigateToSingleListingUpgrade } from '../../utils/upgradeListingNavigation';
import ActionPlanSection from '../../components/ListingScore/components/ActionPlanSection';
import ComponentAnalysisSection from '../../components/ListingScore/components/ComponentAnalysisSection';
import detailStyles from '../../components/ListingScore/bulk_listing_score/ListingScoreResultHistory.module.css';
import listingScoreStyles from '../../components/ListingScore/ListingScore.module.css';

const ListingScoreDetailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedScoreData = location.state?.selectedScoreData;

  if (!selectedScoreData) {
    return (
      <div className={detailStyles.container}>
        <div className={detailStyles.detailedViewHeader}>
          <button
            type="button"
            className={detailStyles.backButton}
            onClick={() => navigate('/dashboard/projects')}
            aria-label="Back"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 8.75H4.7875L11.775 1.7625L10 0L0 10L10 20L11.7625 18.2375L4.7875 11.25H20V8.75Z" fill="#737373"/>
            </svg>
          </button>
          <div className={detailStyles.detailedViewHeaderContent}>
            <h1 className={detailStyles.detailedViewTitle}>Listing Score Analysis</h1>
          </div>
        </div>
        <p>No score data found. Go back to view your listing scores.</p>
      </div>
    );
  }

  return (
    <div className={detailStyles.container}>
      <div className={detailStyles.detailedViewHeader}>
        <button
          type="button"
          className={detailStyles.backButton}
          onClick={() => navigate('/dashboard/projects')}
          aria-label="Back"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 8.75H4.7875L11.775 1.7625L10 0L0 10L10 20L11.7625 18.2375L4.7875 11.25H20V8.75Z" fill="#737373"/>
          </svg>
        </button>
        <div className={detailStyles.detailedViewHeaderContent}>
          <h1 className={detailStyles.detailedViewTitle}>Listing Score Analysis</h1>
          <p className={detailStyles.detailedViewSubtitle}>Real-time evaluation based on Amazon best practices</p>
        </div>
      </div>
      <div className={detailStyles.detailedViewContent}>
        {selectedScoreData.analysis && (
          <>
            <ResultsSection productData={selectedScoreData} onUpgradeListing={(pd) => navigateToSingleListingUpgrade(navigate, pd)} />
            <section className={listingScoreStyles.section2}>
              <ActionPlanSection
                productData={{ analysis: selectedScoreData.analysis }}
                showDetailedAnalysis={true}
              />
              <ComponentAnalysisSection productData={{ analysis: selectedScoreData.analysis }} />
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default ListingScoreDetailPage;
